"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _ui = require("@alycecom/ui");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    root: {
      borderTop: "1px solid ".concat(palette.divider),
      padding: spacing(3)
    },
    description: {
      paddingBottom: spacing(2)
    },
    limitedDescription: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      maxHeight: function maxHeight(props) {
        return "".concat(1.5 * props.rows, "rem");
      },
      '-webkit-line-clamp': function webkitLineClamp(props) {
        return props.rows;
      },
      '-webkit-box-orient': 'vertical'
    },
    chip: {
      marginLeft: spacing(1),
      lineHeight: 1,
      textTransform: 'uppercase',
      fontSize: 12,
      fontWeight: 700
    },
    subtitle: {
      color: palette.primary.main,
      fontStyle: 'italic'
    }
  };
});

var BaseSettingsItem = function BaseSettingsItem(_ref2) {
  var title = _ref2.title,
      _ref2$subtitle = _ref2.subtitle,
      subtitle = _ref2$subtitle === void 0 ? '' : _ref2$subtitle,
      description = _ref2.description,
      isLoading = _ref2.isLoading,
      _ref2$descRowLimit = _ref2.descRowLimit,
      descRowLimit = _ref2$descRowLimit === void 0 ? 0 : _ref2$descRowLimit,
      controls = _ref2.controls,
      value = _ref2.value,
      valueNode = _ref2.valueNode,
      badge = _ref2.badge,
      icon = _ref2.icon,
      hint = _ref2.hint,
      _ref2$overrideClasses = _ref2.overrideClasses,
      overrideClasses = _ref2$overrideClasses === void 0 ? {} : _ref2$overrideClasses;
  var classes = useStyles({
    rows: descRowLimit
  });
  var isControlsExist = controls !== null;
  var separator = value && description ? ':' : '';
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row",
    className: (0, _classnames.default)(classes.root, overrideClasses.root)
  }, icon, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "H4-Dark-Bold"
  }, title), badge && /*#__PURE__*/_react.default.createElement(_material.Chip, {
    size: "small",
    className: (0, _classnames.default)(classes.chip, overrideClasses.chip),
    label: badge
  }), hint && /*#__PURE__*/_react.default.createElement(_material.Tooltip, {
    title: hint
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "inline-flex",
    alignItems: "center",
    ml: 2
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    icon: "info-circle",
    color: "grey"
  }))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    item: true,
    xs: isControlsExist ? 9 : 12
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "Body-Regular-Left-Static"
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "column",
    alignItems: "flex-start"
  }, (description || value || valueNode) && /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 1,
    mb: 1,
    className: (0, _classnames.default)({
      [classes.limitedDescription]: !!descRowLimit
    })
  }, description, valueNode ? /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 1
  }, isLoading ? /*#__PURE__*/_react.default.createElement(_ui.LoadingLabel, null) : valueNode) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, separator, /*#__PURE__*/_react.default.createElement(_material.Box, {
    ml: 1,
    className: "Body-Regular-Left-Chambray-Bold",
    style: {
      display: 'inline-block'
    }
  }, isLoading ? /*#__PURE__*/_react.default.createElement(_ui.LoadingLabel, null) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, value)))), subtitle && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.subtitle
  }, subtitle)))), controls));
};

var _default = /*#__PURE__*/(0, _react.memo)(BaseSettingsItem);

exports.default = _default;